module.exports = __webpack_public_path__ + "static/media/Rwanda.db856913.png";